import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgEyeCrossedIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g>
      <g
        style={{
          stroke: "none",
          strokeWidth: 0,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fillRule: "nonzero",
          opacity: 1,
        }}
      >
        <path
          d="M12.39 79.61a2 2 0 0 1-1.414-3.414l65.221-65.221a2 2 0 1 1 2.828 2.828L13.804 79.024c-.39.391-.903.586-1.414.586zM44.954 72.856c-4.485 0-8.968-.801-13.445-2.406a2 2 0 0 1 1.35-3.766C50.152 72.888 67.815 65.589 85.386 45c-4.967-5.821-9.979-10.632-14.915-14.314a2 2 0 0 1 2.393-3.206c5.545 4.137 11.155 9.601 16.675 16.242a2 2 0 0 1 0 2.557c-14.7 17.683-29.645 26.577-44.585 26.577z"
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            fill: "#000",
            fillRule: "nonzero",
            opacity: 1,
          }}
          transform="translate(1.964 1.964) scale(2.8008)"
        />
        <path
          d="M61.212 39.539c.577 1.715.89 3.551.89 5.461 0 9.445-7.657 17.102-17.102 17.102-1.909 0-3.745-.313-5.459-.89M24.828 67.173a2 2 0 0 1-.982-.258C16.058 62.52 8.19 55.576.462 46.278a2 2 0 0 1 0-2.557C22.128 17.656 44.23 10.712 66.155 23.085a2.002 2.002 0 0 1 .431 3.156L26.242 66.587a1.998 1.998 0 0 1-1.414.586zM4.614 45c6.626 7.766 13.306 13.699 19.89 17.668l37.341-37.343C42.734 15.827 23.977 22.281 4.614 45z"
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            fill: "#000",
            fillRule: "nonzero",
            opacity: 1,
          }}
          transform="translate(1.964 1.964) scale(2.8008)"
        />
        <path
          d="M56.988 32.803A17.044 17.044 0 0 0 45 27.898c-9.445 0-17.102 7.657-17.102 17.102 0 4.723 1.914 8.998 5.009 12.093l24.081-24.29z"
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            fill: "#000",
            fillRule: "nonzero",
            opacity: 1,
          }}
          transform="translate(1.964 1.964) scale(2.8008)"
        />
      </g>
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgEyeCrossedStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgEyeCrossedIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const EyeCrossedIcon: any = SvgEyeCrossedStyle;
export default EyeCrossedIcon;
